export enum AccentColor {
  Bubblegum = "bubblegum",
  Lavender = "lavender",
  Aegean = "aegean",
  Success = "success",
  Warning = "warning",
  Error = "error",
}
